<template>
    <page>
        <module>
            <view-list ref="view" selector :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="收款渠道">
                            <c-select name="check_payment_channel" :options="CHECK_PAYMENT_CHANNEL"></c-select>
                        </m-search-item>
                        <m-search-item label="核销单号">
                            <c-input name="record_number"></c-input>
                        </m-search-item>
                        <m-search-item label="确认人">
                            <c-input name="confirm_user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="确认时间">
                            <c-datetime range start-name="confirm_start_date" end-name="confirm_end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_check_confirm_audit')" color="main" @click="confirmOrder()">批量确认</c-button>
                    <c-button v-if="auth('b_check_confirm_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--收款渠道-->
                <template #check_payment_channel="{data}">
                    <c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="data.check_payment_channel"></c-state>
                </template>
                <!--确认状态-->
                <template #status="{data}">
                    <c-state async tag dict="CHECK_CONFIRM_STATUS" :value="data.status"></c-state>
                </template>
                <!--金额-->
                <template #settlement_amount="{data}">
                    ￥{{data.settlement_amount}}
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="150"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="orderDetail(data)">详情</c-table-button>
                        <c-table-button v-if="auth('b_check_confirm_audit') && data.status == 0" icon="tf-accept" @click="confirmOrder(data)">确认</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
        </module>
    </page>
</template>

<script>
import saasDeposit from '@/mixins/saas_deposit';

import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

export default {
    mixins: [saasDeposit],
    name:'m_check_confirm',

    components: {
    },

    data() {
        return {
            workType: 114,
            defaultSearchData: {
            }
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
        ...asyncMapState(['CHECK_PAYMENT_CHANNEL'])
    },

    methods: {
        /*********打开详情页面**********/
        orderDetail(data) {
            this.globalDialog('orderCheckDetail', {data: data}, () => {
                this.$refs.view.update();
            });
        },
        /**
         * 确认
         */
        confirmOrder(data){
            this.checkDepositBefore(() => {
                var ids = [];
                var message = '';
                var flag = true;
                if (data){
                    ids.push(data.id);
                    message = '是否将对核销单【'+data.record_number+'】的信息确认无误，确认后，货款将自动打款至您的余额';
                }else {
                    let list = this.$refs.view.$refs.list.getData('selected');
                    if (list.length == 0){
                        this.$message({
                            message: '请选择要确认的核销单数据'
                        });
                        flag = false;
                        return;
                    }
                    list.forEach(item => {
                        if (item.status != 0){
                            this.$message({
                                message: '只能选择【待确认】的核销单进行操作',  // 提示内容,
                                type: 'warn'
                            });
                            flag = false;
                            return
                        }
                    });
                    list.forEach(item => {
                        ids.push(item.id);
                    });
                    message = '是否将选择的【'+ids.length+'】个确认单进行确认操作，确认后，货款将自动打款至您的余额';
                }
                if (flag){
                    this.$confirm({
                        title: '核销单确认',
                        message: message,
                        resolve: () => {
                            this.request({
                                url: '/sale/check/confirm',
                                data: {
                                    ids:ids,
                                },
                                loading: true,
                                success: () => {
                                    this.$message({
                                        message: '确认完成'
                                    });
                                    this.$refs.view.update();
                                }
                            })
                        }
                    });
                }
            });
        }
    }
}
</script>


<style lang="stylus" scoped>
.factory {
    border: 1px solid var(--unit-line);
    border-radius: 0 10px 10px 10px;
    border-top: none;
    padding: 26px;
    margin: 0 15px 15px;
    overflow: auto;
    background: #fff;

    &-tab {
        margin: 0 15px;

        >>> ul {
            padding-left: 0;
        }
    }

    &-logo {
        margin-right: 28px;

        &-image {
            position: relative;
            width: 100px;
            height: 100px;
            font-size: 24px;
            color: #ccc;
            background: #242738;

            &:hover {
                color: var(--color-main);

                .factory-logo-handle {
                    display: flex;
                }
            }
        }

        &-handle {
            gap: 20px;
            display: none;
            position: absolute;
            inset: 0;
            font-size: 20px;
            color: #fff;
            background: rgba(0,0,0,.6);

            a {
                font-size: 20px;

                &:hover {
                    color: var(--color-main);
                }
            }
        }

        &-name {
            gap: 5px;
            margin-top: 10px;
            font-size: 13px;
            color: #666;
        }
    }

    &-name {
        height: 32px;
        gap: 12px;

        p {
            font-size: 22px;
            font-weight: bold;
        }

        a {
            font-size: 20px;
            color: var(--color-main);
        }

        input {
            box-sizing: border-box;
            width: 200px;
            height: 100%;
            border: 1px solid #ccc;
            padding: 0 10px;

            &:focus {
                border-color: var(--color-main);
            }
        }

        >>> .c-button {
            height: 32px !important;
        }
    }

    &-code {
        display: inline-block;
        border: 1px solid #ddd;
        border-radius: 15px;
        padding: 0 16px;
        margin-top: 10px;
        line-height: 28px;
        font-size: 14px;
    }

    &-info {
        margin-top: 34px;

        td {
            height: 36px;
            font-size: 14px;

            &:nth-child(1) {
                color: #666;
            }

            &:nth-child(2) {
                padding-left: 20px;
            }

            .edition {
                border-radius: 4px;
                padding: 0 8px;
                margin-right: 10px;
                line-height: 24px;
                font-size: 13px;
                color: #fff;
                background: #F5F5F5;
            }

            .tag {
                border-radius: 4px;
                padding: 0 12px;
                margin: 0 10px;
                line-height: 26px;
                font-size: 15px;
                font-weight: bold;
                background: #F5F5F5;

                span {
                    color: var(--color-main);
                }
            }
        }
    }

    &-handle {
        gap: 20px;
        margin-top: 20px;

        >>> .c-button {
            border-radius: 4px;
        }
    }
}

.templet-list {
    gap: 20px;
    box-sizing: border-box;
    padding: 20px;

    .item {
        width: 300px;
        border-radius: 6px;
        overflow: hidden;
        background: #F9F9F9;
        transition: box-shadow .3s ease;

        &:hover {
            box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
        }

        .cover {
            height: 200px;
            overflow: hidden;

            .image {
                height: 100%;
                background-size: cover;
                background-position: center;
                transition: transform .3s ease;

                ^[-2]:hover ^[-2..-1] {
                transform: scale(1.2);
            }
            }
        }

        .info {
            padding: 6px 25px 0;

            h5 {
                line-height: 50px;
                font-size: 18px;
            }

            ul {
                li {
                    position: relative;
                    padding: 6px 0 6px 24px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;

                    .tf {
                        position: absolute;
                        left: 0;
                        top: 0;
                        line-height: 32px;
                        font-size: 15px;
                        color: var(--color-main);
                    }
                }
            }
        }

        .button {
            padding: 16px 0 20px;

            >>> .c-button {
                width: 108px;
                height: 36px !important;
            }
        }
    }
}

.data-type {
    gap: 15px;
    padding: 20px;

    li {
        position: relative;
        border: 1px solid #F5F5F5;
        border-radius: 4px;
        padding: 20px;
        background: #F5F5F5;
        cursor: pointer;

        h5 {
            margin-bottom: 14px;
            font-size: 16px;
            font-weight: normal;
        }

        p {
            line-height: 22px;
        }

        &.z-crt,
        &:hover {
            border-color: var(--color-main);
            background: #fff;
        }

        &.z-crt {
            &:before {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                border-top: 24px solid var(--color-main);
                border-left: 28px solid rgba(0,0,0,0);
            }

            &:after {
                content: '\e63f';
                position: absolute;
                right: 2px;
                top: 2px;
                font-family: 'iconfont';
                font-size: 10px;
                color: #fff;
            }
        }
    }
}

.notice {
    &-delete {
        padding: 5px;
        font-size: 15px;
        color: #f00;

        &:hover {
            border-radius: 4px;
            background: #F5F5F5;
        }
    }

    &-temp {
        height: 520px;

        &-tip {
            margin-left: 20px;
        }
    }

    &-guide {
        align-self: flex-start;
        position: sticky;
        top: 0;
        padding: 26px 30px 20px;
        background: #FAFAFA;

        &-tip {
            margin-bottom: 12px;
            font-size: 13px;
            color: #f55;
        }

        &-arrow {
            position: relative;
            width: 60px;
            height: 1px;
            margin: 90px 16px 0;
            background: #999;

            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: -5px;
                border-left: 10px solid #999;
                border-top: 5px solid rgba(0,0,0,0);
                border-bottom: 5px solid rgba(0,0,0,0);
            }
        }

        &-item {
            width: 180px;

            img {
                height: 180px;
            }

            p {
                margin: 14px 0 10px;
                font-size: 14px;
                font-weight: bold;
                white-space: nowrap;
                color: #f55;
            }

            span {
                line-height: 20px;
                font-size: 13px;
                color: #999;
            }
        }
    }
}
</style>